__turbopack_context__.v({
  "buttonsWrapper": "nWG1sq_buttonsWrapper",
  "errorIcon": "nWG1sq_errorIcon",
  "errorMessage": "nWG1sq_errorMessage",
  "errorText": "nWG1sq_errorText",
  "formHeader": "nWG1sq_formHeader",
  "formWrapper": "nWG1sq_formWrapper",
});
